import meta from '@core/scripts/helper/meta';
import {fetchData} from '@checkout/components/common/forms/helper/fetchDataHelper';
import CheckoutMessages from '@checkout/components/message-list';
import Url from '@core/scripts/helper/url';
import MessageBroker from 'deprecated-shared-ui/components/message-broker';

export interface PreSignUpTexts {
    invalid_captcha: string;
    restriction_email_already_in_use: string;
    throttled_by_email: string;
    email_not_allowed: string;
    [key: string]: string;
}

export interface PreSignUpRequest {
    salutation?: string;
    firstName: string;
    lastName: string;
    email: string;
    emailRepeat: string;
    password?: string;
    receiveNewsletter?: string;
    permanentLoginConsent?: string;
    captchaToken?: string;
}

export const doUpdateDataBackendRequest = (
    texts: PreSignUpTexts,
    request: PreSignUpRequest,
    url: string,
    onGlobalError: (message?: string) => void,
    onEmailNotAllowedError: () => void,
    onValidationError: (errors: Array<{name: string; message: string}>) => void,
    onResetCaptcha: () => void,
    onRequestEnd: () => void,
    onGeneralError: () => void,
) => {
    fetchData(url, {...request, csrf: meta.value('_csrf')}, handleUpdateDataResponse, onGeneralError);

    function handleUpdateDataResponse(data: {
        status: string;
        inputValidationErrors?: Array<{name: string; message: string}>;
    }) {
        switch (data.status) {
            case 'INPUT_VALIDATION_ERROR':
                onValidationError(data.inputValidationErrors ?? []);
                onResetCaptcha();
                break;
            case 'CAPTCHA_NOT_SUCCESSFUL':
                onGlobalError(texts['invalid_captcha']);
                onResetCaptcha();
                break;
            case 'EMAIL_ALREADY_IN_USE':
                const message = texts.restriction_email_already_in_use;
                MessageBroker.publish(CheckoutMessages.PRESIGNUP.EMAIL_ALREADY_IN_USE, {
                    email: request.email,
                    message: message,
                });
                onResetCaptcha();
                break;
            case 'EMAIL_NOT_ALLOWED':
                onEmailNotAllowedError();
                onResetCaptcha();
                break;
            case 'SUCCESS':
                const urlSearchParams = new URLSearchParams(window.location.search);
                const params = Object.fromEntries(urlSearchParams.entries());
                const isCheckout = params.hasOwnProperty('checkout');
                const redirectTarget = params.hasOwnProperty('target') ? params['target'] : '/';
                if (isCheckout) {
                    window.location.href = Url.toAbsolute('/buy/signup/');
                } else {
                    window.location.href = Url.toAbsolute(redirectTarget);
                }
                setTimeout(onRequestEnd, 30000);
                break;
            case 'THROTTLED_BY_EMAIL_ERROR':
                onGlobalError(texts['throttled_by_email']);
                onResetCaptcha();
                break;
            case 'UNRESOLVEABLE_BACKEND_ERROR':
            case 'EXTERNAL_ERROR':
            default:
                onGeneralError();
                onResetCaptcha();
                break;
        }
    }
};
